import IResult from "../../models/result/IResult";
import { sendGet, sendPost, sendPut, sendDelete } from "./generic";
import { APPLICATION_VARIABLE } from "../../constants/Urls";
import ApplicationVariable from "../../models/applications/ApplicationVariable";

export const getApplicationVariablesByApplicationId = (applicationId: string): Promise<IResult<ApplicationVariable[]>> => {
    return sendGet<ApplicationVariable[]>(`${APPLICATION_VARIABLE}/forApplication/${applicationId}`);
}

export const getApplicationVariableById = (applicationVariableId: string): Promise<IResult<ApplicationVariable>> => {
    return sendGet<ApplicationVariable>(`${APPLICATION_VARIABLE}/${applicationVariableId}`);
}

export const createApplicationVariable = (model: ApplicationVariable): Promise<IResult<ApplicationVariable>> => {
    return sendPost<ApplicationVariable>(`${APPLICATION_VARIABLE}`, model);
}

export const updateApplicationVariable = (applicationVariableId: string, model: ApplicationVariable): Promise<IResult<ApplicationVariable>> => {
    return sendPut<ApplicationVariable>(`${APPLICATION_VARIABLE}/${applicationVariableId}`, model);
}

export const deleteApplicationVariable = (applicationVariableId: string): Promise<IResult<ApplicationVariable>> => {
    return sendDelete<ApplicationVariable>(`${APPLICATION_VARIABLE}/${applicationVariableId}`);
}
